import { useState, useEffect, useRef, Fragment } from "react";
import { useHistory } from "react-router-dom";
import {
	getAuth,
	signInWithCustomToken,
	db,
	doc,
	getDoc,
	updateDoc,
} from "../firebase";
import { API_URL, scroll, getValFromLS } from "../helpers";
import Hdg from "../components/Hdg";
import Alert from "../components/Alert";
import Editor from "../components/Editor";
import Msg from "../components/Msg";
import Submit from "../components/Submit";
import Nav from "./Nav";

const EmailSend = () => {
	const [user, setUser] = useState({});
	const [html, setHtml] = useState("");
	const [, setErrors] = useState([]);
	const [names] = useState({});
	const [msg, setMsg] = useState({});
	const [alert, setAlert] = useState({
		type: "working",
		text: "",
	});

	const formElement = useRef(null);
	const editorRef = useRef(null);
	const history = useHistory();

	const emailId = getValFromLS("emailId", true)
		? getValFromLS("emailId", true)
		: "";

	useEffect(() => {
		const init = async () => {
			const token = getValFromLS("vtoUserToken")
				? getValFromLS("vtoUserToken")
				: "";
			const url = new URL(`${API_URL}/admin/emailEditInit`);
			const params = {
				token,
			};
			url.search = new URLSearchParams(params);

			try {
				const response = await fetch(url, {
					method: "GET",
					cache: "no-store",
				});
				const json = await response.json();

				if (emailId) {
					if (json && json.resp === 1) {
						setUser({ ...json.user });
						scroll();
						handleFirebAuth(json.firebToken);
					} else {
						setAlert({
							type: json.resp === 2 ? "notice" : "error",
							text: json.text,
						});
					}
				} else {
					history.push("/admin/email");
				}
			} catch (error) {
				setAlert({
					type: "error",
					text: "An error has occurred.",
				});
			}
		};

		init();

		// eslint-disable-next-line
	}, []);

	const handleFirebAuth = (token) => {
		const auth = getAuth();
		signInWithCustomToken(auth, token)
			.then(async (userCredential) => {
				// Signed in userCredential.user;

				const docRef = doc(db, "bfcEmails", emailId);
				const docSnap = await getDoc(docRef);

				if (docSnap.exists()) {
					setHtml(docSnap.data().html);
					setAlert({});
				} else {
					// doc.data() will be undefined in this case
					console.log("No such document!");
				}
			})
			.catch((error) => {
				setAlert({
					type: "error",
					text: `Error ${error.message} (${error.code}).`,
				});
			});
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setErrors([]);
		setMsg({
			type: "working",
			text: "",
		});

		const editorHtml = editorRef.current ? editorRef.current.getContent() : "";

		const url = new URL(`${API_URL}/admin/emailEdit`);
		let data = new FormData();
		Object.entries(names).forEach(([key, value]) => {
			data.append(key, value);
		});
		data.append("html", editorHtml);
		data.append("token", getValFromLS("vtoUserToken"));

		try {
			const response = await fetch(url, {
				method: "POST",
				body: data,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				const docRef = doc(db, "bfcEmails", emailId);
				await updateDoc(docRef, {
					html: editorHtml,
				});

				history.push("/admin/email/send");
			} else {
				setErrors(json.fields);
				setMsg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	return (
		<Fragment>
			{alert.type ? (
				<Alert data={alert} />
			) : (
				<Fragment>
					<div id="left-column">
						<Hdg section="Admin Edit Email" />

						<p>Use this form to edit your current working email.</p>

						<div className="spacer"></div>

						<form
							ref={formElement}
							method="post"
							action="/"
							onSubmit={(e) => handleSubmit(e)}
							className="well"
						>
							<h4 style={{ marginBottom: "12.5px" }}>ID: {emailId}</h4>

							<div className="form-group one">
								<Editor
									editorRef={editorRef}
									label="Edit Email Content"
									reqd={true}
									value={html}
								/>
							</div>

							<div className="msg-submit">
								{msg.type && <Msg data={msg} />}

								<div
									className={
										msg.type === "working" || msg.type === "success"
											? "hidden"
											: "submit-container"
									}
								>
									<Submit submit="Preview / Send Email" />
								</div>
							</div>
						</form>

						<div className="spacer"></div>
					</div>

					<div id="right-column">
						<Nav on={0} user={user} />
					</div>
				</Fragment>
			)}
		</Fragment>
	);
};

export default EmailSend;
